// @flow

import { Button } from "../common";
import { Eye } from "../icons";
import { MiniTicketCard } from "../cards";
import { Wrapper } from "./Notification.styles";
import React from "react";
import theme from "views/resources/theme";
import type { Line, Office, Ticket } from "types";

interface Props {
	office: Office;
	line: Line;
	ticket: Ticket;
	onClose(): void;
}

const AlmostThere = ({
	office,
	line,
	ticket,
	category,
	onClose,
	by,
}: Props) => {
	const color = "orange";
	return (
		<Wrapper color={theme.icons[color]}>
			{office.category_id ? (
				<MiniTicketCard
					category={category}
					office={office}
					line={line}
					ticket={ticket}
					clickable={false}
				/>
			) : (
				"Cargando..."
			)}
			<Eye size={10} color={theme.icons[color]} />
			<h2>¡Atención! Faltan {by} personas para tu turno</h2>
			<Button onClick={onClose} gradient={color}>
				Entendido
			</Button>
		</Wrapper>
	);
};

export default AlmostThere;
